import React from 'react';
import { SEO } from '@/components/SEO';
import Navbar from '@/components/Navbar';
import Breadcrumbs from '@/components/ui/Breadcrumbs';
import Services from '@/components/Services';
import CallToAction from '@/components/CallToAction';
import ContactForm from '@/components/ContactForm';
import Footer from '@/components/Footer';

const services = [
  { name: "Pressure Washing", path: "/services/pressure-washing", description: "High-pressure cleaning for driveways, patios, decks, and exterior surfaces." },
  { name: "Soft Wash", path: "/services/soft-wash", description: "Low-pressure, biodegradable cleaning safe for stucco, siding, and roofs." },
  { name: "Window Washing", path: "/services/window-washing", description: "Streak-free interior and exterior window cleaning." },
  { name: "Carpet Cleaning", path: "/services/carpet-cleaning", description: "Deep extraction carpet and upholstery cleaning." },
  { name: "Gutter Cleaning", path: "/services/gutter-cleaning", description: "Debris removal and downspout inspection to prevent water damage." },
  { name: "Solar Panel Cleaning", path: "/services/solar-panel-cleaning", description: "Eco-friendly cleaning to restore lost solar efficiency." },
  { name: "Dumpster Pad Cleaning", path: "/services/dumpster-pad-cleaning", description: "Degreasing and sanitizing for restaurants, HOAs, and commercial properties." },
];

const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "itemListElement": services.map((service, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "item": {
      "@type": "Service",
      "name": service.name,
      "description": service.description,
      "url": `https://www.venturapowerwashing.com${service.path}`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "Ventura Power Washing"
      },
      "areaServed": [
        "Ventura", "Oxnard", "Camarillo", "Thousand Oaks", "Simi Valley",
        "Fillmore", "Moorpark", "Port Hueneme", "Santa Paula"
      ]
    }
  }))
};

const ServicesPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Cleaning Services in Ventura County, CA | Ventura Power Washing"
        description="Pressure washing, soft wash, window cleaning, carpet cleaning, gutter cleaning, and solar panel cleaning throughout Ventura County. Free estimates, licensed & insured."
        keywords="pressure washing Ventura County, soft wash, window cleaning, carpet cleaning, gutter cleaning, solar panel cleaning"
        path="/services"
      >
        <script type="application/ld+json">
          {JSON.stringify(servicesSchema)}
        </script>
      </SEO>

      <Navbar />
      <main>
        <div className="container mx-auto px-4 pt-24">
          <Breadcrumbs
            items={[
              { label: "Home", href: "/" },
              { label: "Services", href: "/services" }
            ]}
          />
        </div>
        <section className="pt-8 pb-12">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
                Cleaning Services in Ventura County
              </h1>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                Comprehensive pressure washing, soft wash, window, carpet, gutter, and solar panel cleaning for your home or business
              </p>
            </div>
          </div>
        </section>

        <Services />
        <CallToAction />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;